import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';
import Breadcrumb from '../../components/Breadcrumb';

import errorImg from '../../assets/img/error/error.png';

const ErrorMain = () => {
  return (
    <main>
      <Breadcrumb title="Error" />

      <div className="it-error-area pt-120 pb-120">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12">
              <div className="it-error-wrap text-center">
                <div className="it-error-thumb mb-70">
                  <img src={errorImg} alt="" />
                </div>
                <div className="it-error-content">
                  <h5
                    className="it-error-title wow animate__fadeInUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".3s"
                  >
                    OooPs! Page Not Found
                  </h5>
                  <p
                    className="mb-25 wow animate__fadeInUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".5s"
                  >
                    Oops! The page you are looking for does not exist. It might
                    have been moved <br /> or deleted. Please check and try
                    again.
                  </p>
                  <Link
                    className="it-btn-theme mr-30 wow animate__fadeInUp"
                    data-wow-duration=".9s"
                    data-wow-delay=".7s"
                    to="/"
                  >
                    <Button btnText="Back To Home" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ErrorMain;
